import { Fragment } from 'react';
import { StyleSheet, View } from 'react-native';
import Collapsible from 'react-native-collapsible';
import { Divider, Icon, Radio, Text } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import ListItem from '../../../Components/ListItem';
import constants from '../../../Config/constants';
import AddressHelper from '../../../Helper/Address';
import ThemeColor from '../../../Theme/colors';
import ThemeStyle, { globalSpacing } from '../../../Theme/styles';

type Props = {
  disabled: boolean;
  list: string[];
  selectedId?: string;
  show: boolean;
  getRow: (
    addressId: string,
    index: number,
  ) => { address: any; isSelected: boolean; isLast: boolean };
  onSelect: (param: any) => void;
  toggle: () => void;
};

const LastUsedAddresses = ({
  disabled,
  list,
  show,
  getRow,
  onSelect,
  toggle,
}: Props) => {
  const hasLastUsedAddresses = !lodashIsEmpty(list);
  return (
    <Fragment>
      {hasLastUsedAddresses && (
        <View style={styles.container}>
          <ListItem
            contentContainerStyle={ThemeStyle.pageVerticalSpacingMedium}
            leftIcon={{
              color: ThemeColor.green,
              name: 'clock-outline',
              size: 20,
            }}
            title={
              <View
                style={[
                  !constants.isWeb && ThemeStyle.flex1,
                  ThemeStyle.flexDirectionRowCenter,
                  styles.contentContainer,
                ]}
              >
                <Text style={!constants.isWeb && ThemeStyle.flex1}>{`${
                  !show ? 'Show' : 'Hide'
                } last used addresses`}</Text>
                <Icon
                  name={!show ? 'chevron-down' : 'chevron-up'}
                  fill={ThemeColor.green}
                  style={styles.rightIcon}
                />
              </View>
            }
            spacing={20}
            onPress={toggle}
          />
        </View>
      )}
      {hasLastUsedAddresses && show && <Divider style={ThemeStyle.divider} />}
      {/* Last used address accordion */}
      {hasLastUsedAddresses && (
        <Collapsible collapsed={!show} renderChildrenCollapsed={false}>
          {list.map((addressId: string, index: number) => {
            const { address, isSelected, isLast } = getRow(addressId, index);
            return (
              <View
                style={[ThemeStyle.flex1, { marginLeft: globalSpacing * 2 }]}
                key={address?.id || index}
              >
                <ListItem
                  contentContainerStyle={ThemeStyle.pageVerticalSpacingMedium}
                  accessoryLeft={
                    <Radio
                      checked={isSelected}
                      status={isSelected ? 'success' : 'basic'}
                      style={ThemeStyle.spacingRight}
                      onChange={() => onSelect(address)}
                    />
                  }
                  title={AddressHelper.getDisplayTitle(address)}
                  subTitle={AddressHelper.getDisplaySubTitle(address)}
                  onPress={() => onSelect(address)}
                  disabled={disabled}
                />
                {!isLast && <Divider style={ThemeStyle.divider} />}
              </View>
            );
          })}
        </Collapsible>
      )}
    </Fragment>
  );
};
const styles = StyleSheet.create({
  container: { marginLeft: constants.isWeb ? 10 : 0 },
  contentContainer: { marginLeft: constants.isWeb ? -5 : 0, columnGap: 10 },
  rightIcon: { width: 20, height: 20 },
});
export default LastUsedAddresses;
